export const steps = [
  { name: 'Avatar', num: 1 },
  { name: 'Voice', num: 2 },
  { name: 'Persona', num: 3 },
  { name: 'Knowledge', num: 4 }
];
